export enum WorkStepKey {
  WORK = 'WORK',
  SOWING_PRODUCTS = 'SOWING_PRODUCTS',
  SPRAYING_PRODUCTS = 'SPRAYING_PRODUCTS',
  OTHER_PRODUCTS = 'OTHER_PRODUCTS',
  DETAILS = 'DETAILS',
  OVERVIEW = 'OVERVIEW',
}
